export default "__VITE_ASSET__s25dZIlt__"